export async function processComplementaryRecommendations({
  products,
}: {
  products: any;
}): Promise<any[]> {
  const totalRecommendations = 10;
  const selectedProducts: Set<any> = new Set();

  const categories = Object.keys(products);
  const productsPerCategory = Math.floor(
    totalRecommendations / categories.length,
  );
  const extraProducts = totalRecommendations % categories.length;

  for (let i = 0; i < categories.length; i++) {
    const category = categories[i];
    const subCategories = Object.keys(products[category]);
    const count = productsPerCategory + (i < extraProducts ? 1 : 0);

    let productPool: any[] = [];

    for (const subCategory of subCategories) {
      const productIds = products[category][subCategory];
      const fetchedProducts = await Promise.all(
        productIds.map(async (id: string) => {
          try {
            const product = await window.helium.datastore.getProduct({ id });
            return { ...product?.details, category };
          } catch (e) {
            console.error(
              "Error fetching product in cart inline block func",
              e,
            );
            return null;
          }
        }),
      );
      productPool = productPool.concat(fetchedProducts.filter(Boolean));
    }

    productPool = productPool.sort(() => Math.random() - 0.5);

    for (let j = 0; j < Math.min(count, productPool.length); j++) {
      selectedProducts.add(productPool[j]);
    }
  }

  const finalProducts = Array.from(selectedProducts).slice(
    0,
    totalRecommendations,
  );
  return finalProducts;
}

export async function processSimilarProductRecommendations({
  products,
}: {
  products: string[][];
}) {
  const tags: { [key: string]: any[] } = {};

  for (const productIds of products) {
    await Promise.all(
      productIds.map(async (productId) => {
        const p = (
          await window.helium.datastore
            .getProduct({
              id: productId,
            })
            .catch((e) => {
              console.error(
                "Error fetching product in cart inline block func",
                e,
              );
            })
        )?.details;
        const productTags = await window.helium.datastore
          .getTags({
            id: p?.handle!,
          })
          .catch((e) => {
            console.error("Error fetching tags in cart inline block func", e);
            return {};
          });

        const product = {
          ...p,
          category: productTags.subcategory.split("/")[1] || "Uncategorized",
        };
        Object.keys(productTags).forEach((key) => {
          if (!tags[key]) {
            tags[key] = [];
          }
          tags[key].push(product);
        });
      }),
    ).catch((e) => {
      console.error(
        "Error fetching products & tags in cart inline block func",
        e,
      );
    });
  }

  const totalRecommendations = 10;
  const recommendedProducts: Set<any> = new Set();

  const categoryEntries = Object.entries(tags);
  const productsPerCategory = Math.floor(
    totalRecommendations / categoryEntries.length,
  );
  const extraProducts = totalRecommendations % categoryEntries.length;

  // Select products evenly from each category
  for (let i = 0; i < categoryEntries.length; i++) {
    const [category, productList] = categoryEntries[i];
    const count = productsPerCategory + (i < extraProducts ? 1 : 0);

    let selectedCount = 0;

    for (const product of productList) {
      if (selectedCount < count && !recommendedProducts.has(product)) {
        recommendedProducts.add(product);
        selectedCount++;
      }
    }
  }

  return Array.from(recommendedProducts).slice(0, totalRecommendations);
}
